import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { environmentOm } from '../../environment-om';

import { IReport, ReportDataType } from './report-list.component';

@Injectable()
export class ReportLauncher {

    location: Location;

    public reports: IReport[] = [
        {
            name: 'projectListReport',
            title: 'Project List Report',
            component: 'ProjectListReport',
            selector: 'om-project-list-report',
            inputs: {
                'project-ids': 'projectIds'
            }
        },
        {
            name: 'projectStatusReport',
            title: 'Project Status Report',
            component: 'project-status-report',
            inputs: {
                'project-id': 'projectId'
            }
        },
        {
            name: 'bridgeDataReport',
            title: 'Bridge Data Report',
            component: 'bridge-data-report',
            inputs: {
                'bridge-ids': 'bridgeKeys'
            }
        },
        {
            name: 'basicBridgeReport',
            title: 'Basic Bridge Report',
            component: 'basic-bridge-report',
            inputs: {
                'bridge-id': 'bridgeId'
            }
        },
        {
            name: 'detailBridgeReport',
            title: 'Detail Bridge Report',
            component: 'detail-bridge-report',
            inputs: {
                'bridge-id': 'bridgeId'
            }
        },
        {
            name: 'hopDetailReport',
            title: 'Hop Detail Report',
            component: 'hop-detail-report',
            inputs: {
                objectId: 'hopId',
                layerId: 'layerId'
            }
        },
        {
            name: 'municipalityAssetTipReport',
            title: 'Municipality Asset TIP Report',
            component: 'municipality-asset-tip-report',
            inputs: {
                'municipal-id': 'municipalityId',
                'county-municipality-code': 'countyMunicipalityCode'
            }
        },
        {
            name: 'municipalityAssetDraftTipReport',
            title: 'Municipality Asset Draft TIP Report',
            component: 'municipality-asset-draft-tip-report',
            inputs: {
                'municipal-id': 'municipalityId',
                'county-municipality-code': 'countyMunicipalityCode'
            }
        },
        {
            name: 'legislativeAssetTipReport',
            title: 'Legislative Asset TIP Report',
            component: 'legislative-asset-tip-report',
            inputs: {
                'congress-district-number': 'congressDistrictNumber',
                'senate-district-number': 'senateDistrictNumber',
                'house-district-number': 'houseDistrictNumber'
            }
        },
        {
            name: 'legislativeAssetDraftTipReport',
            title: 'Legislative Asset Draft TIP Report',
            component: 'legislative-asset-draft-tip-report',
            inputs: {
                'congress-district-number': 'congressDistrictNumber',
                'senate-district-number': 'senateDistrictNumber',
                'house-district-number': 'houseDistrictNumber'
            }
        },
        {
            name: 'planningStatsTipReport',
            title: 'Planning Stats Tip Report',
            component: 'planning-stats-tip-report',
            inputs: {
                'planning-partner-short-name': 'planningPartnerShortName'
            }
        },
        {
            name: 'planningStatsDraftTipReport',
            title: 'Planning Stats Draft Tip Report',
            component: 'planning-stats-draft-tip-report',
            inputs: {
                'planning-partner-short-name': 'planningPartnerShortName'
            }
        },
        {
            name: 'projectDetailReport',
            title: 'Project Detail Report',
            component: 'project-detail-report',
            inputs: {
                'project-id': 'projectId'
            }
        },
        {
            name: 'sdBridgeReport',
            title: 'Poor Bridge Condition Report',
            component: 'sd-bridge-report',
            inputs: {
                'bridge-ids': 'bridgeKeys'
            }
        },
        {
            name: 'sdBridgeSummaryReport',
            title: 'Poor Bridge Condition Summary Report',
            component: 'sd-bridge-summary-report',
            inputs: {
                'bridge-ids': 'bridgeKeys'
            }
        },
        {
            name: 'opiProjectEvaluationTipReport',
            title: 'OPI Project Evaluation TIP Report',
            component: 'opi-project-evaluation-tip-report',
            inputs: {
                'project-ids': 'projectIds',
                'district-number': 'districtNumber',
                'county-number': 'countyNumber',
                'municipal-id': 'municipalityId',
                'county-municipality-code': 'countyMunicipalityCode',
                'congress-district-number': 'congressDistrictNumber',
                'senate-district-number': 'senateDistrictNumber',
                'house-district-number': 'houseDistrictNumber',
                'planning-partner-short-name': 'planningPartnerShortName'
            }
        },
        {
            name: 'opiProjectEvaluationDraftTipReport',
            title: 'OPI Project Evaluation Draft TIP Report',
            component: 'opi-project-evaluation-draft-tip-report',
            inputs: {
                'project-ids': 'projectIds',
                'district-number': 'districtNumber',
                'county-number': 'countyNumber',
                'municipal-id': 'municipalityId',
                'county-municipality-code': 'countyMunicipalityCode',
                'congress-district-number': 'congressDistrictNumber',
                'senate-district-number': 'senateDistrictNumber',
                'house-district-number': 'houseDistrictNumber',
                'planning-partner-short-name': 'planningPartnerShortName'
            }
        },
        {
            name: 'iriProjectEvaluationTipReport',
            title: 'IRI Project Evaluation TIP Report',
            component: 'iri-project-evaluation-tip-report',
            inputs: {
                'project-ids': 'projectIds',
                'district-number': 'districtNumber',
                'county-number': 'countyNumber',
                'municipal-id': 'municipalityId',
                'county-municipality-code': 'countyMunicipalityCode',
                'congress-district-number': 'congressDistrictNumber',
                'senate-district-number': 'senateDistrictNumber',
                'house-district-number': 'houseDistrictNumber',
                'planning-partner-short-name': 'planningPartnerShortName'
            }
        },
        {
            name: 'iriProjectEvaluationDraftTipReport',
            title: 'IRI Project Evaluation Draft TIP Report',
            component: 'iri-project-evaluation-draft-tip-report',
            inputs: {
                'project-ids': 'projectIds',
                'district-number': 'districtNumber',
                'county-number': 'countyNumber',
                'municipal-id': 'municipalityId',
                'county-municipality-code': 'countyMunicipalityCode',
                'congress-district-number': 'congressDistrictNumber',
                'senate-district-number': 'senateDistrictNumber',
                'house-district-number': 'houseDistrictNumber',
                'planning-partner-short-name-short-name': 'planningPartnerShortName'
            }
        }
    ];

    constructor(
        private readonly router: Router,
        location: Location
    ) {
        this.location = location;
     }

    public findReport(reportName) {
        for (const report of this.reports) {
            if (report.name.toLowerCase() === reportName.toLowerCase()) {
                return report;
            }
        }
    }

    /**
     * @param reportName Report name should be full name of report in camel case i.e 'projectListReport'
     * @param reportData report data parameters should reflect required report inputs as shown in models from lines 4-195 in report-launcher.ts. Example: {project-ids: [1,2,3]}
     */
    generateReport(reportName: string, reportData?: ReportDataType[]) {
        const report = this.findReport(reportName);
        const localStorageData: { [key: string]: string } = {};
        if (reportData) {
            for (const attributeName of Object.keys(report.inputs)) {
                const attributeValue = report.inputs[attributeName];
                localStorageData[attributeValue] = reportData[attributeValue];
            }
        }
        const reportKeys = Object.keys(window.localStorage).filter(x => x.includes('reportData'));
        const maxLength = 200;
        if (reportKeys.length > maxLength) {
            reportKeys.sort((a, b) => a.localeCompare(b));
            window.localStorage.removeItem(reportKeys[0]);
        }
        const newReportKey = 'reportData-' + Date.now().toString();
        window.localStorage.setItem(newReportKey, JSON.stringify(localStorageData));
        const url = `${environmentOm.oneMapURL}${environmentOm.oneMapURL.endsWith('/') ? '' : '/'}${report.name}/${newReportKey}`;
        window.open(url, '_blank');
    }
}
